import styled from 'styled-components';
export const StyledFooter = styled.tfoot `
  position: sticky;
  bottom: 0;
`;
